import { useState } from "react";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";
import logo from "@/assets/logo.png";

export default function LoginForm({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onSuccess(data.token);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Accesso non riuscito. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-night px-5">
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-3xl border border-ivory/15 bg-white/5 p-8 backdrop-blur-md sm:p-10"
      >
        <div className="mb-8 text-center">
          <img src={logo} alt="Gelateria Imperiale" data-testid="admin-login-logo" className="mx-auto h-24 w-auto" />
          <p className="mt-2 font-mono-alt text-[10px] uppercase tracking-[0.3em] text-ivory/50">
            Area Riservata Gestore
          </p>
        </div>
        <label className="mb-2 block font-mono-alt text-[10px] uppercase tracking-[0.22em] text-ivory/60">Email</label>
        <input
          data-testid="admin-login-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mb-5 w-full rounded-xl border border-ivory/20 bg-night/60 px-4 py-3 text-sm text-ivory outline-none transition-colors focus:border-ivory/60"
          placeholder="admin@gelateriaimperiale.it"
        />
        <label className="mb-2 block font-mono-alt text-[10px] uppercase tracking-[0.22em] text-ivory/60">Password</label>
        <input
          data-testid="admin-login-password-input"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-6 w-full rounded-xl border border-ivory/20 bg-night/60 px-4 py-3 text-sm text-ivory outline-none transition-colors focus:border-ivory/60"
          placeholder="••••••••"
        />
        {error && (
          <p data-testid="admin-login-error" className="mb-4 rounded-lg bg-bordeaux/20 px-4 py-2 text-sm text-ivory">
            {error}
          </p>
        )}
        <button
          data-testid="admin-login-button"
          type="submit"
          disabled={loading}
          className="flex w-full items-center justify-center gap-2 rounded-full bg-bordeaux py-3.5 font-mono-alt text-xs uppercase tracking-[0.22em] text-ivory transition-transform duration-300 hover:scale-[1.02] disabled:opacity-60"
        >
          <Lock className="h-4 w-4" /> {loading ? "Accesso in corso…" : "Accedi"}
        </button>
      </form>
    </div>
  );
}
